import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { fetchAllPages } from "@/lib/pagedList";
import { useRestClient } from "@/lib/restClient";
import type { Tenant } from "@/types";

type TenantRow = Omit<Tenant, "tenant_id"> & { tenant_id: string | number };

/** Every readable tenant (reference data for names and selectors), page after page. */
export function useTenants() {
  const auth = useAuth();
  const apiFetch = useRestClient();

  return useQuery({
    queryKey: ["tenants"],
    queryFn: async ({ signal }) => {
      const tenants = await fetchAllPages<TenantRow>(apiFetch, "/api/tenants", "tenants", {
        signal,
      });
      return tenants.map((tenant) => ({ ...tenant, tenant_id: String(tenant.tenant_id) }));
    },
    enabled:
      !auth.isLoading && auth.isAuthenticated && !!auth.user?.access_token && !auth.user.expired,
    staleTime: 5 * 60_000,
  });
}
